import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-208ac1b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { class: "q-pa-md" }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","margin-bottom":"15px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Cereri de avans", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { style: {"display":"flex","align-items":"start"} }
const _hoisted_10 = { style: {"width":"65%","display":"flex","flex-direction":"row"} }
const _hoisted_11 = { style: {"display":"flex","flex-direction":"column","width":"100%"} }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Id", -1))
const _hoisted_14 = { class: "col-8 form__label__black" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Pentru deplasare", -1))
const _hoisted_17 = { class: "col-8 form__label__black" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "De la data", -1))
const _hoisted_20 = {
  key: 0,
  class: "col-8 row"
}
const _hoisted_21 = { class: "form__label__black" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Pana la data", -1))
const _hoisted_24 = {
  key: 0,
  class: "col-8 row"
}
const _hoisted_25 = { class: "form__label__black" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Tara", -1))
const _hoisted_28 = { class: "col-8 form__label__black" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Oras", -1))
const _hoisted_31 = { class: "col-8 form__label__black" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Mijloc de transport", -1))
const _hoisted_34 = { class: "col-8 form__label__black" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Detalii / scop", -1))
const _hoisted_37 = { class: "col-8 form__label__black" }
const _hoisted_38 = { style: {"width":"35%","display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"} }
const _hoisted_39 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_40 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Documente atasate", -1))
const _hoisted_42 = {
  class: "text__label--thin",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_43 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_44 = {
  key: 1,
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"50vh"}
}
const _hoisted_45 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_46 = { class: "mobile-only" }
const _hoisted_47 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--medium",
  style: {"margin-bottom":"15px"}
}, "Solicit avans pentru", -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { style: {"display":"flex","align-items":"center","justify-content":"center"} }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { style: {"width":"400px","display":"center"} }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-8 form__label" }, "Cheltuieli de transport", -1))
const _hoisted_55 = { class: "col-4 form__label__black" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-8 form__label" }, "Diurna", -1))
const _hoisted_58 = { class: "col-4 form__label__black" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-8 form__label" }, "Cazare", -1))
const _hoisted_61 = { class: "col-4 form__label__black" }
const _hoisted_62 = {
  key: 0,
  clas: "row",
  style: {"margin-top":"5px","margin-bottom":"15px"}
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = {
  class: "absolute-bottom-right q-pa-sm",
  style: {"margin-top":"15px","margin-right":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_DialogOpenScan = _resolveComponent("DialogOpenScan")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_TaskList = _resolveComponent("TaskList")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_q_form, { ref: "myForm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  })
                      }, _hoisted_8, 2)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.cerere.id_cerere), 1)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.cerere.denumire_pentru), 1)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _hoisted_19,
                            (_ctx.cerere.data_start != null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.displayData(_ctx.cerere.data_start)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            (_ctx.cerere.data_end != null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.displayData(_ctx.cerere.data_end)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.cerere.denumire_tara), 1)
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.cerere.denumire_localitate), 1)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.getDenMijlocTransport(_ctx.cerere.id_mijl_transport as number)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.cerere.denumire_pentru), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", {
                            class: _normalizeClass({
                        column: _ctx.$q.platform.is.mobile,
                        row: _ctx.$q.platform.is.desktop,
                        })
                          }, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", null, [
                                _hoisted_41,
                                _withDirectives(_createElementVNode("div", _hoisted_42, " Nimic atasat ", 512), [
                                  [_vShow, 
                                  _ctx.cerere.scan_documents != null &&
                                  _ctx.cerere.scan_documents.length == 0 &&
                                  !_ctx.uploadingFileToServer
                              ]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", null, [
                                (_ctx.uploadingFileToServer)
                                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                                      key: 0,
                                      color: "primary",
                                      size: "3em",
                                      thickness: 10
                                    }))
                                  : (_openBlock(), _createElementBlock("table", _hoisted_44, [
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cerere.scan_documents, (scan) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: scan.appid
                                          }, [
                                            _createElementVNode("td", null, _toDisplayString(scan.file_ext), 1),
                                            _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan.file_size)), 1),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("div", _hoisted_45, _toDisplayString(scan.description), 1),
                                              _createElementVNode("div", _hoisted_46, _toDisplayString(scan.description), 1)
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_q_btn, {
                                                round: "",
                                                color: "black",
                                                icon: "cloud_download",
                                                size: "xs"
                                              }),
                                              _createVNode(_component_q_menu, {
                                                fit: "",
                                                "transition-show": "scale",
                                                "transition-hide": "scale"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_DialogOpenScan, {
                                                    appid: scan.appid,
                                                    type_scan: "Cereri"
                                                  }, null, 8, ["appid"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ]))
                              ])
                            ])
                          ], 2)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", {
                        class: _normalizeClass({
                    column: _ctx.$q.platform.is.mobile,
                    row: _ctx.$q.platform.is.desktop,
                  })
                      }, _hoisted_49, 2)
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _hoisted_54,
                            _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.cerere.valoare_transport), 1)
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _hoisted_57,
                            _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.cerere.valoare_diurna), 1)
                          ]),
                          _createElementVNode("div", _hoisted_59, [
                            _hoisted_60,
                            _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.cerere.valoare_cazare), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.cerere.stare !== 'initiat')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _createVNode(_component_TaskList, {
                          appid: _ctx.appid,
                          task: _ctx.task,
                          onState: _ctx.onState,
                          isSuccess: _ctx.isSuccess
                        }, null, 8, ["appid", "task", "onState", "isSuccess"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  (_ctx.cerere.appid !== 0)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        label: "DESCARCA CERERE",
                        color: "brown",
                        onClick: _ctx.onDownload,
                        style: {"margin-left":"5px"},
                        size: "sm"
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_btn, {
                    label: "Renunt",
                    type: "reset",
                    size: "sm",
                    flat: "",
                    onClick: _ctx.onCancel,
                    style: {"margin-left":"5px"}
                  }, null, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          }, 512)
        ]))
  ]))
}